<template>
	<button
		type="button"
		:title="title"
		:disabled="disabled"
		:class="classes"
		@click="onClick"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: 'action',
	props: {
		title: String,
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		classes() {
			return ['action', { 'action--disabled': this.disabled }]
		}
	},
	methods: {
		onClick(event) {
			if (!this.disabled) this.$emit('click', event)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
.action {
	@include circle-button(1.5rem);
}
</style>
